import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'agenda-customer-ui-hhh',
  templateUrl: './hhh.component.html',
})
export class HhhComponent implements OnInit {
  constructor() {
    console.log('Hello from HhhComponent constructor');

  }
  ngOnInit(): void {
    console.log('Hello from HhhComponent');
  }
}
